import { GroupingsService } from './../../../_services/groupings.service';
import { AdminService } from './../../../_services/admin.service';


import { ActivatedRoute} from '@angular/router';
import { Component, OnInit } from '@angular/core';
declare var window: any;

@Component({
  selector: 'app-subscription-grouping-show',
  templateUrl: './subscription-grouping-show.component.html',
  styleUrls: ['./subscription-grouping-show.component.css']
})
export class SubscriptionGroupingShowComponent implements OnInit {

  trialModal:any=undefined
  subscriptionGrouping:any = undefined
  subscriptionGroup:any = undefined
  loading=false
  constructor(
    private activatedRoute:ActivatedRoute,
    private adminService:AdminService, private groupingsService:GroupingsService) { }

  ngOnInit(): void {
    this.loading=true
    this.activatedRoute.params.subscribe(
      params =>{

        this.adminService.getSubscriptionGrouping(params['server_subscription_grouping_id']).subscribe(
          sG=>{
            this.subscriptionGrouping = sG
            this.groupingsService.minGroupingData.next(this.subscriptionGrouping)
            this.groupingsService.subscriptionGrouping=sG
            this.subscriptionGroup=this.subscriptionGrouping['subscriptionGroup']
            this.loading=false
          }
        )
      }
    )
  }
  openNewStudentPopup(){
    this.trialModal = new window.bootstrap.Modal(
      document.getElementById('groupRegStudentModal')
    );
    this.trialModal.show()
  }

 closeModalByName(closeModalName:string){

  switch(closeModalName){
    case "trialEnrolModal":
       this.trialModal.hide()
    default:
      ;
  }
  }
  removeGrouping(server_subscription_grouping_id:number){

  }


}
